import React, { useState } from 'react';
import ImageGalleryIRCCHARITY from '../components/ImageGalleryIRCCHARITY';
import ImageGalleryIRCCHARITYdental from '../components/ImageGalleryIRCCHARITYdental';
import ImageGalleryIRCCHARITYpatho from '../components/ImageGalleryIRCCHARITYpatho';
import IRCTVDonationCard from "./IRCTVDonationCard";
import { useStats } from '../hooks/useStats';

const IRCCHARITY = () => {
  const { stats, loading } = useStats();

  // State for each section
  const [charityQuantity, setCharityQuantity] = useState(1);
  const [dentalQuantity, setDentalQuantity] = useState(1);
  const [pathologyQuantity, setPathologyQuantity] = useState(1);

  // Base amounts
  const charityBaseAmount = 80;
  const dentalBaseAmount = 500;
  const pathologyBaseAmount = 150;

  // Format date for display
  const formatDisplayDate = (dateString) => {
    if (!dateString) return '31-Jan-2025';
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Format number with commas
  const formatNumber = (num) => {
    if (!num && num !== 0) return 'Loading...';
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  // Function to handle phone number clicks
  const handlePhoneClick = (phoneNumber) => {
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    const telLink = `tel:${cleanedNumber}`;
    window.location.href = telLink;
  };

  // Charity Clinic handlers
  const handleCharityIncrease = () => setCharityQuantity(prev => prev + 1);
  const handleCharityDecrease = () => setCharityQuantity(prev => prev > 1 ? prev - 1 : 1);
  const handleCharityQuantityChange = (e) => {
    const value = parseInt(e.target.value) || 1;
    setCharityQuantity(value > 0 ? value : 1);
  };

  // Dental Clinic handlers
  const handleDentalIncrease = () => setDentalQuantity(prev => prev + 1);
  const handleDentalDecrease = () => setDentalQuantity(prev => prev > 1 ? prev - 1 : 1);
  const handleDentalQuantityChange = (e) => {
    const value = parseInt(e.target.value) || 1;
    setDentalQuantity(value > 0 ? value : 1);
  };

  // Pathology Lab handlers
  const handlePathologyIncrease = () => setPathologyQuantity(prev => prev + 1);
  const handlePathologyDecrease = () => setPathologyQuantity(prev => prev > 1 ? prev - 1 : 1);
  const handlePathologyQuantityChange = (e) => {
    const value = parseInt(e.target.value) || 1;
    setPathologyQuantity(value > 0 ? value : 1);
  };

  // Calculate totals
  const charityTotalAmount = charityQuantity * charityBaseAmount;
  const dentalTotalAmount = dentalQuantity * dentalBaseAmount;
  const pathologyTotalAmount = pathologyQuantity * pathologyBaseAmount;

  if (loading) return <div className="loading">Loading statistics...</div>;

  return (
    <>
      <div className="about-us-container">
        {/* Charity Clinics Section */}
        <section className="activities-details">
          <button
            onClick={() => window.history.back()}
            style={{
              marginBottom: '10px',
              padding: '8px 10px',
              backgroundColor: '#255fe8',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            ← Back to All Activities
          </button>
          <ImageGalleryIRCCHARITY />

          {/* IRC Charitable Clinics */}
          <div className="activity-card">
            <div className="activity-header">
              <h3>IRC CHARITABLE CLINICS (ICC)</h3>
            </div>
            <div className="activity-content">
              <p>In the heart of Aurangabad's slum communities, IRC runs 3 Charitable Clinics that have served over 3 lakh patients with affordable consultations and free medication. Open to all, regardless of faith, these clinics offer compassionate, accessible healthcare where it's needed most. Your support helps keep their doors open and ensures no patient is turned away for lack of money.</p>

              <div className="clinic-card">
                <h4>Clinic - 1 - Baijipura</h4>
                <p><strong>Name:</strong> IRC Charitable Clinic</p>
                <p><strong>Address:</strong> Gali No. 34, Apex Hospital Road, Behind Sikandar Funtion Hall, Baijipura, Chhatrapati Sambhajinagar (Aurangabad) - 431003.</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> 01-Jun-2016</p>
                <p><strong>No. of Patients Treated:</strong> {formatNumber(stats.baijipura_patients)} (till {formatDisplayDate(stats.baijipura_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('80-5555-7732')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    80-5555-7732
                  </span>
                </p>
              </div>

              {/* <div className="clinic-card">
                <h4>Clinic - 2 - Kiradpura</h4>
                <p><strong>Name:</strong> IRC Charitable Clinic</p>
                <p><strong>Address:</strong> Shop No 3, SK Tower, Plot No 1, Zone No 3, Jaswantpura, Kiradpura, Chhatrapati Sambhajinagar (Aurangabad) - 431001</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> 27-Jun-2019</p>
                <p><strong>No. of Patients Treated:</strong> {formatNumber(stats.kiradpura_patients)} (till {formatDisplayDate(stats.kiradpura_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('8507-8507-32')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    8507-8507-32
                  </span>
                </p>
                <p><strong>Old Address:</strong> H, No.1, Lane No. 4, Noorani Masjid, Jahangir Colony, Chhatrapati Sambhajinagar (Aurangabad) - 431008.</p>
                <p><strong>Old Address:</strong> Gut No. 250, Plot No. 12 & 13, Jatwada Rd, beside Mohammadi Masjid, Ambar Hill, Chhatrapati Sambhajinagar (Aurangabad) - 431008</p>
              </div> */}

              {/* <div className="clinic-card">
                <h4>Clinic - 3 - Shah Bazar</h4>
                <p><strong>Name:</strong> Khurshid Meraj IRC Charitable Clinic</p>
                <p><strong>Address:</strong> # 2-2-66, Behind Chelipura Police Chauki, Shah Bazar, Chhatrapati Sambhajinagar (Aurangabad) - 431001.</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> 03-Mar-2021</p>
                <p><strong>No. of Patients Treated:</strong> {formatNumber(stats.shahbazar_patients)} (till {formatDisplayDate(stats.shahbazar_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('8507-8507-33')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    8507-8507-33
                  </span>
                </p>
              </div> */}

              {/* <div className="clinic-card">
                <h4>Clinic - 4 - Shahnoorwadi</h4>
                <p><strong>Name:</strong> IRC Charitable Clinic</p>
                <p><strong>Address:</strong> Beside Shahnawaz Shaheed Masjid, Chausar, Shahnoorwadi, Chhatrapati Sambhajinagar (Aurangabad) - 431005.</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> 10-Jun-2021</p>
                <p><strong>No. of Patients Treated:</strong> {formatNumber(stats.shahnoorwadi_patients)} (till {formatDisplayDate(stats.shahnoorwadi_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('8507-8507-34')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    8507-8507-34
                  </span>
                </p>
              </div> */}

              {/* <div className="clinic-card">
                <h4>Clinic - 5 - Misarwadi</h4>
                <p><strong>Name:</strong> IRC Charitable Clinic</p>
                <p><strong>Address:</strong> Plot No. 19, Gali No. 10, Bismillah Colony, Misarwadi, Chhatrapati Sambhajinagar (Aurangabad) - 431007.</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> 26-Oct-2021</p>
                <p><strong>No. of Patients Treated:</strong> {formatNumber(stats.misarwadi_patients)} (till {formatDisplayDate(stats.misarwadi_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('7537-9999-11')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    7537-9999-11
                  </span>
                </p>
              </div> */}

              <div className="clinic-card">
                <h4>Clinic - 2 - Buddi Lane</h4>
                <p><strong>Name:</strong> IRC Charitable Clinic</p>
                <p><strong>Address:</strong> H.No 1-13-37, Near Nehru Bhawan, Fatima Maternity Hospital Road, Buddi Lane, Chhatrapati Sambhajinagar (Aurangabad) - 431001</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Start:</strong> 1-Nov-2022</p>
                <p><strong>No. of Patients Treated:</strong> {formatNumber(stats.buddilane_patients)} (till {formatDisplayDate(stats.buddilane_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('7537-9999-22')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    7537-9999-22
                  </span>
                </p>
              </div>
              <div className="clinic-card">
                <h4>Clinic - 3 - Ibrahim Park</h4>
                <p><strong>Name:</strong> IRC Charitable Clinic</p>
                <p><strong>Address:</strong> Gut No. 33, Soniya Nagar, Ibrahim Park, Satara Deolai Parisar, Beed By Pass Road, Aurangabad.</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/IRC+Community+Centre+Ibrahim+Park/@19.8516085,75.3061167,54m/data=!3m1!1e3!4m6!3m5!1s0x3bdb9939008d5771:0x78edc41cf90a24d5!8m2!3d19.8515497!4d75.3062471!16s%2Fg%2F11vsdq1xmd?entry=ttu&g_ep=EgoyMDI2MDEyOC4wIKXMDSoKLDEwMDc5MjA3MUgBUAM%3D" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> NA</p>
                <p><strong>No. of Patients Treated:</strong> {formatNumber(stats.misarwadi_patients)} (till {formatDisplayDate(stats.misarwadi_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('8507-8507-34')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    8507-8507-34
                  </span>
                </p>
              </div>

            </div>


            {/* Charity Clinic Donation Card */}
            <IRCTVDonationCard
              title="IRC CHARITABLE CLINICS (ICC)"
              subtitle="Your donation makes a difference"
              description="Donate Us continue providing quality healthcare services to underserved communities."
              baseAmount={charityBaseAmount}
              quantity={charityQuantity}
              onIncrease={handleCharityIncrease}
              onDecrease={handleCharityDecrease}
              onQuantityChange={handleCharityQuantityChange}
              totalAmount={charityTotalAmount}
              purpose={`Support to treatement ${charityQuantity} patient${charityQuantity > 1 ? 's' : ''}`}
              behalf="Donation Options"
              behalfdescription="Choose how many people you want to support"
              showQuantityControls={true}
              serviceType="charity"
            />
          </div>
        </section>

        {/* Dental Clinics Section */}
        <section className="activities-details">
          <button
            onClick={() => window.history.back()}
            style={{
              marginBottom: '10px',
              padding: '8px 10px',
              backgroundColor: '#255fe8',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            ← Back to All Activities
          </button>
          <ImageGalleryIRCCHARITYdental />

          {/* IRC Dental Clinic */}
          <div className="activity-card">
            <div className="activity-header">
              <h3>IRC DENTAL CLINIC (IDC)</h3>
            </div>
            <div className="activity-content">
              <p>Our Dental Clinics restore more than just smiles. With over 15,000 patients treated, we provide essential dental care—cleanings, fillings, root canals, dentures—at heavily subsidized rates, along with free medicines. Your donation gives vulnerable individuals the chance to eat, speak, and smile without pain.</p>

              <div className="clinic-card">
                <h4>Clinic - 1 - Baijipura</h4>
                <p><strong>Name:</strong> IRC Dental Clinic</p>
                <p><strong>Address:</strong> IRC Community Centre, First Floor, Gali No. 34, Apex Hospital Road, Behind Sikandar Hall, Baijipura, Chhatrapati Sambhajinagar (Aurangabad) - 431003.</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> 08-Jun-2023</p>
                <p><strong>No. of Patients Treated:</strong> {formatNumber(stats.dental_baijipura_patients)} (till {formatDisplayDate(stats.dental_baijipura_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('9607-9607-67')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    9607-9607-67
                  </span>
                </p>
              </div>

              <div className="clinic-card">
                <h4>Clinic - 2 - Kiradpura</h4>
                <p><strong>Name:</strong> IRC Dental Clinic</p>
                <p><strong>Address:</strong> Shop No 3, SK Tower, Plot No 1, Zone No 3, Jaswantpura, Kiradpura, Chhatrapati Sambhajinagar (Aurangabad) - 431001</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> 18-Sep-2024</p>
                <p><strong>No. of Patients Treated:</strong> {formatNumber(stats.dental_kiradpura_patients)} (till {formatDisplayDate(stats.dental_kiradpura_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('8507-8507-32')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    8507-8507-32
                  </span>
                </p>
              </div>

              <div className="clinic-card">
                <h4>Clinic - 3 - Buddi Lane</h4>
                <p><strong>Name:</strong> IRC Dental Clinic</p>
                <p><strong>Address:</strong> H.No 1-13-37, Near Nehru Bhawan, Fatima Maternity Hospital Road, Buddi Lane, Chhatrapati Sambhajinagar (Aurangabad) - 431001</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> NA</p>
                <p><strong>No. of Patients Treated:</strong> {stats.dental_buddilane_patients === 0 ? 'NA' : formatNumber(stats.dental_buddilane_patients)} (till {formatDisplayDate(stats.dental_buddilane_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('7537-9999-22')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    7537-9999-22
                  </span>
                </p>
              </div>

              <div className="clinic-card">
                <h4>Clinic - 4 - Ibrahim Park</h4>
                <p><strong>Name:</strong> IRC Dental Clinic</p>
                <p><strong>Address:</strong> Gut No. 33, Soniya Nagar, Ibrahim Park, Satara Deolai Parisar, Beed By Pass Road, Aurangabad. - 431001</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/IRC+Community+Centre+Ibrahim+Park/@19.8516085,75.3061167,54m/data=!3m1!1e3!4m6!3m5!1s0x3bdb9939008d5771:0x78edc41cf90a24d5!8m2!3d19.8515497!4d75.3062471!16s%2Fg%2F11vsdq1xmd?entry=ttu&g_ep=EgoyMDI2MDEyOC4wIKXMDSoKLDEwMDc5MjA3MUgBUAM%3D" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> NA</p>
                <p><strong>No. of Patients Treated:</strong> {stats.dental_buddilane_patients === 0 ? 'NA' : formatNumber(stats.dental_buddilane_patients)} (till {formatDisplayDate(stats.dental_buddilane_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('7537-9999-22')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    7537-9999-22
                  </span>
                </p>
              </div>
            </div>

            {/* Dental Clinic Donation Card */}
            <IRCTVDonationCard
              title="IRC DENTAL CLINIC (IDC)"
              subtitle="Restore smiles with your support"
              description="Donate Us provide essential dental care to those in need. Your donation covers dental treatments, medications, and oral health services."
              baseAmount={dentalBaseAmount}
              quantity={dentalQuantity}
              onIncrease={handleDentalIncrease}
              onDecrease={handleDentalDecrease}
              onQuantityChange={handleDentalQuantityChange}
              totalAmount={dentalTotalAmount}
              purpose={`Dental care for ${dentalQuantity} patient${dentalQuantity > 1 ? 's' : ''}`}
              behalf="Donation Options"
              behalfdescription="Choose how many people you want to support"
              showQuantityControls={true}
              serviceType="dental"
            />
          </div>
        </section>

        {/* Pathology Lab Section */}
        <div className="about-us-container">
          <section className="activities-details">
            <button
              onClick={() => window.history.back()}
              style={{
                marginBottom: '10px',
                padding: '8px 10px',
                backgroundColor: '#255fe8',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '16px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              ← Back to All Activities
            </button>
            <ImageGalleryIRCCHARITYpatho />

            {/* IRC Pathology Laboratory */}
            <div className="activity-card">
              <div className="activity-header">
                <h3>IRC PATHOLOGY LABORATORY</h3>
              </div>
              <div className="activity-content">
                <p>Accurate diagnosis saves lives. Our Pathology Lab provides vital lab testing at 60% subsidized rates for the poor, easing the burden of high medical costs. With over 24,000 tests conducted so far, your contribution enables early detection, proper treatment, and peace of mind for families who would otherwise go without.</p>

                <div className="clinic-card">
                  <p><strong>Name:</strong> IRC Pathology Laboratory</p>
                  <p><strong>Address:</strong> Ground Floor, IRC Community Centre, Gali No. 34, Apex Hospital Rd, behind Sikandar Funtion Hall, Baijipura, Chhatrapati Sambhajinagar (Aurangabad) - 431001</p>
                  <p>
                    <strong>Location: </strong>
                    <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                      📍Click here for Location
                    </a>
                  </p>
                  <p><strong>Date of Inauguration:</strong> 17-Jul-2019</p>
                  <p><strong>No. of Patients Tested:</strong> {formatNumber(stats.pathology_patients)} (till {formatDisplayDate(stats.pathology_date)})</p>
                  <p>
                    <strong>Contact No: </strong>
                    <span
                      className="contact-number"
                      onClick={() => handlePhoneClick('9607-9607-68')}
                      style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                    >
                      9607-9607-68
                    </span>
                  </p>
                </div>
              </div>

              {/* Pathology Lab Donation Card */}
              <IRCTVDonationCard
                title="IRC PATHOLOGY LABORATORY"
                subtitle="Enable accurate diagnoses"
                description="Donate Us provide affordable diagnostic services to the community. Your support covers lab tests, equipment maintenance, and reagents."
                baseAmount={pathologyBaseAmount}
                quantity={pathologyQuantity}
                onIncrease={handlePathologyIncrease}
                onDecrease={handlePathologyDecrease}
                onQuantityChange={handlePathologyQuantityChange}
                totalAmount={pathologyTotalAmount}
                purpose={`Lab tests for ${pathologyQuantity} patient${pathologyQuantity > 1 ? 's' : ''}`}
                behalf="Donation Options"
                behalfdescription="Choose how many people you want to support"
                showQuantityControls={true}
                serviceType="pathology"
              />
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default IRCCHARITY;